import layoutsSlice, { LayoutsSlice as _LayoutsSlice } from './layoutsSlice'

export type LayoutsSlice = _LayoutsSlice
export const layoutsReducer = layoutsSlice.reducer
export const layoutsActions = layoutsSlice.actions
export default layoutsSlice